import type { ModuleEntry, ModuleGroup } from '../modules.tsx'

/**
 * O que cada menu da barra de menus do Modo PC mostra — F138.
 *
 * Um menu por grupo do catálogo (`MODULE_GROUPS`), com as telas na ordem do
 * catálogo. Uma tela que mora sob outra — Etiquetas, Preços e Estoque sob
 * Produtos (`parent`), as abas sob a página de configuração (`inTab`) — vem
 * logo abaixo dela, recuada, e não solta no meio do menu.
 *
 * Se a pessoa não vê a tela de cima, a de baixo sobe e aparece sozinha: o
 * mesmo acordo da barra lateral (`sidebar-sections.ts`), porque sumir junto com
 * o pai seria esconder uma tela que a pessoa pode abrir.
 */

export type MenuEntry = {
  readonly entry: ModuleEntry
  readonly children: readonly ModuleEntry[]
}

const ownerOf = (entry: ModuleEntry) => entry.parent ?? entry.inTab

export const menuSections = (
  visible: readonly ModuleEntry[]
): ReadonlyMap<ModuleGroup, readonly MenuEntry[]> => {
  const shown = new Set(visible.map((entry) => entry.module))
  const sections = new Map<ModuleGroup, MenuEntry[]>()

  for (const entry of visible) {
    const owner = ownerOf(entry)
    if (owner !== undefined && shown.has(owner)) continue

    const children = visible.filter((child) => ownerOf(child) === entry.module)
    const list = sections.get(entry.group) ?? []
    list.push({ entry, children })
    sections.set(entry.group, list)
  }

  return sections
}
